<template>
  <div
    class="flex items-center flex-shrink-0 transition-all duration-300"
    :class="{
      'w-20': !menu,
      'w-136': menu
    }"
  >
    <div class="h-full flex-grow flex-shrink" @click="onToggleMenu('')"></div>
    <div
      class="fixed right-6 z-10 flex flex-col gap-3"
      :style="{
        top: 'calc(3.75rem + ((100vh - 3.75rem) / 2))',
        transform: 'translateY(-50%)'
      }"
    >
      <div
        v-for="item in menuOptions"
        :key="item.value"
        class="h-12 w-12 flex items-center justify-center text-center rounded border cursor-pointer"
        :class="{
          'border-light-purple bg-light-purple': menu === item.value,
          'border-slate-400 bg-pure-white': menu !== item.value
        }"
        :title="item.value"
        @click="onToggleMenu(item.value)"
      >
        <BlIcon
          :icon="item.icon"
          class="h-8 w-8"
          :color="menu === item.value ? 'white' : 'slate-8'"
        />
      </div>
    </div>
    <div
      class="fixed z-20 min-w-116 py-px bg-pure-white border border-slate-400 rounded-xl shadow-lg overflow-y-auto"
      :class="{ 'right-20': menu, '-right-140': !menu }"
      :style="{
        top: 'calc(3.75rem + ((100vh - 3.75rem) / 2))',
        transform: 'translateY(-50%)',
        maxHeight: 'calc(100vh - 3.75rem - 3rem)'
      }"
    >
      <Setting
        v-if="menu === 'Setting'"
        class="w-116"
        @close="onToggleMenu('')"
      />
      <AddGraph
        v-if="menu === 'Add graph'"
        class="w-116"
        :dragId="dragId"
        :recommendedTargets="recommendedTargets"
        @close="onToggleMenu('')"
        @change-focus-id="$emit('change-focus-id', $event)"
        @drag-start="$emit('drag-start', $event)"
      />
      <ViewComments
        v-if="menu === 'View comments'"
        class="min-w-116"
        :settings="viewCommentsSettings"
        :selectedTargetId="viewCommentsTargetId"
        @change-settings="viewCommentsSettings = $event"
        @set-target-id="viewCommentsTargetId = $event"
        @close="onToggleMenu('')"
      />
      <TableOfContents
        v-if="menu === 'View table of contents'"
        class="w-116"
        :sectionFocusedId="sectionFocusedId"
        @close="onToggleMenu('')"
        @change-focus-id="$emit('change-focus-id', $event)"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { displayDate } from "@/plugins/helper.js";

import Setting from "./helper/Setting.vue";
import AddGraph from "./helper/AddGraph.vue";
import ViewComments from "./helper/ViewComments.vue";
import TableOfContents from "./helper/TableOfContents.vue";

import BlIcon from "../BlIcon.vue";

export default {
  name: "ReportHelper",
  props: {
    sectionFocusedId: { type: Number },
    dragId: { type: Number }
    // @change-focus-id
    // @drag-start
  },
  components: {
    Setting,
    AddGraph,
    ViewComments,
    TableOfContents,
    BlIcon
  },
  data() {
    return {
      menu: "",
      menuOptions: [
        { value: "Setting", icon: "settings" },
        { value: "Add graph", icon: "line-chart" },
        { value: "View comments", icon: "paper-note" },
        { value: "View table of contents", icon: "list" }
        // { value: "image", icon: ""},
      ],
      recommendedTargets: [],
      viewCommentsSettings: {
        sort_by: "oldest", // oldest | newest
        session_display: "all", // all | with-comment
        view_option: "all" // all | result | comment
      },
      viewCommentsTargetId: 0
    };
  },
  computed: {
    ...mapGetters(["report"])
  },
  watch: {},
  mounted() {},
  methods: {
    ...mapActions(["actionGet"]),
    displayDate,
    onToggleMenu(val) {
      if (val === this.menu) {
        this.menu = "";
        return;
      } else if (!this.menu) {
        this.menu = val;
      } else {
        this.menu = "";
        setTimeout(() => {
          this.menu = val;
        }, 150);
      }

      if (val === "Add graph") {
        this.fetchRecommendedTargets();
      }
    },
    fetchRecommendedTargets() {
      const start = this.displayDate({
        date: this.report.start_date,
        format: "YYYY-MM-DD"
      });
      const end = this.displayDate({
        date: this.report.end_date,
        format: "YYYY-MM-DD"
      });
      let params = `?start_date=${start}&end_date=${end}`;
      params += `&template_type=progress_highlights`;
      const data = {
        url: `/api/v1/clients/${this.report.client_id}/reports/display_targets${params}`
      };
      this.actionGet(data).then(({ success, data }) => {
        if (!success) return;
        this.recommendedTargets = [...data].sort((a, b) =>
          a.name.localeCompare(b.name)
        );
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/reports/ReportHelper.vue